import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private readonly loading$ = signal<number>(0);
  readonly loading = computed(() => {
    return !!this.loading$();
  });

  constructor() {}

  setLoading(loading: boolean) {
    this.loading$.set(loading ? this.loading$() + 1 : Math.max(0, this.loading$() - 1));
  }
}
